module.exports = __webpack_public_path__ + "media/agent_1_yureru_s.4a1a7c7c.mp3";